import { useState } from 'react';

const ruToEnMap: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
};

const exceptions: Record<string, string> = {
    россия: 'Russia',
    'российская федерация': 'Russian Federation',
    москва: 'Moscow',
    'санкт-петербург': 'Saint Petersburg',
    новосибирск: 'Novosibirsk',
    екатеринбург: 'Yekaterinburg',
    'нижний новгород': 'Nizhny Novgorod',
    казань: 'Kazan',
    челябинск: 'Chelyabinsk',
    омск: 'Omsk',
    самара: 'Samara',
    'ростов-на-дону': 'Rostov-on-Don',
    уфа: 'Ufa',
    красноярск: 'Krasnoyarsk',
    пермь: 'Perm',
    воронеж: 'Voronezh',
    волгоград: 'Volgograd',
    краснодар: 'Krasnodar',
    ульяновск: 'Ulyanovsk',
    сша: 'USA',
    америка: 'America',
    'соединенные штаты': 'United States',
    германия: 'Germany',
    франция: 'France',
    италия: 'Italy',
    испания: 'Spain',
    китай: 'China',
    япония: 'Japan',
    бразилия: 'Brazil',
    индия: 'India',
};

function capitalizeFirstLetter(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getCorrectTransliteration(text: string): string {
    const trimmed = text.trim();
    if (!trimmed) return trimmed;

    const lowerText = trimmed.toLowerCase();
    let result: string;

    if (exceptions[lowerText]) {
        result = exceptions[lowerText];
    } else {
        result = lowerText.split('').map((ch) => ruToEnMap[ch] || ch).join('');
        result = result.replace(/[ъь]/g, '');
    }

    if (trimmed[0] === trimmed[0].toUpperCase() && result.length > 0) {
        result = capitalizeFirstLetter(result);
    }

    return result;
}

export function useTransliterationAutocomplete() {
    const [options, setOptions] = useState<{ value: string }[]>([]);

    const generateSuggestions = (searchText: string) => {
        if (!searchText.trim()) {
            setOptions([]);
            return;
        }
        const corrected = getCorrectTransliteration(searchText);
        if (corrected !== searchText && corrected.trim()) {
            setOptions([{ value: corrected }]);
        } else {
            setOptions([]);
        }
    };

    return { options, generateSuggestions };
}
